import { z } from 'zod';
import { parseMarginRateInput } from '@/utils/common/parseMarginRateInput';

export const MarginRateSchema = z
  .union([
    z.literal(''),
    z.preprocess(
      parseMarginRateInput,
      z.coerce
        .number({ message: 'Le taux de marge est requis' })
        .min(0, 'Le taux de marge doit être supérieur ou égal à 0')
        .max(100, 'Le taux de marge doit être inférieur à 100'),
    ),
  ])
  .transform((v) => (v === '' ? undefined : v));

/**
 * Maps a dirty margin-rate field to an API payload.
 * - not dirty → omit (`undefined`)
 * - empty → clear override (`null`, fall back to parent rate)
 * - `0` → explicit zero margin (`0`)
 */
export const resolveMarginRateForApiUpdate = (
  isDirty: boolean,
  value: unknown,
): number | null | undefined => {
  if (!isDirty) return undefined;
  if (value === undefined || value === null || value === '') return null;
  const parsed = MarginRateSchema.safeParse(value);
  if (!parsed.success) return undefined;
  return parsed.data ?? null;
};
